export const links = {
  docs: {
    home: 'https://docs.hypurr.fi/introduction/hypurrfi',
    eMode: '',
    isolationMode: '',
    siloedMode: '',
    isolationModeBorrowingPower: '',
    supplyBorrowCaps: '',
    dsr: '',
    ssr: '',
    healthFactor: '',
    supplying: '',
    borrowing: '',
    sparkAirdrop: '',
    security: 'https://docs.hypurr.fi/introduction/security',
  },
  aaveTechnicalPaper: 'https://github.com/aave/aave-v3-core/blob/master/techpaper/Aave_V3_Technical_Paper.pdf',
  termsOfUse: '',
  social: {
    followX: 'https://x.com/intent/follow?screen_name=HypurrFi',
    x: 'https://x.com/hypurrfi',
    telegram: 'https://t.me/+YvsBvSxlQrVhNDkx',
    github: 'https://github.com/lastdotnet',
    discord: 'https://discord.com/invite/CvJPEJjBNn',
  },
  audits: '/',
} as const
